const ERROR_DETAILS = {
  evicertia: 'evicertia',
};

export default ERROR_DETAILS;
